export type TemplateListItem = {
  id: string;
  title: string;
  note: string | null;
  fileName: string;
  primary: boolean;
};
